import
    React, {
    useEffect,
    useRef
} from 'react';

import {
    Environment
} from '@vodacom/web-env';

import {
    Environments
} from '@vodacombusiness/web-vb-common';

import {
    WebAssetService
} from '../../services/web-asset-service';

export const HeaderFooter = () => {

    const headerRef = useRef();

    useEffect(() => {

        (async function() {

            const headerResponse = await WebAssetService.getHeaderFragment();

            if (headerResponse.ok && headerRef.current?.children?.length === 0) {
                if (Environment.current?.name === 'Local') {
                    headerResponse.result = headerResponse.result.replace('$("header").load(\'/fragment-header\');', `$("header").load('${Environments.Dev.uiHost}/fragment-header');`);
                }

                const fragment = document.createRange().createContextualFragment(headerResponse.result);
                headerRef.current?.append(fragment);
            }
        })();
    }, []);

    return (
        <div ref={headerRef}></div>
    );
};